var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import { PostDataType } from '@amityco/js-sdk';
import TextContent from './text';
import ImageContentList from './image';
import VideoContentList from './video';
import FileContentList from './file';
import File from '../../../../../core/components/Uploaders/File';
import Image from '../../../../../core/components/Uploaders/Image';
import Video from '../../../../../core/components/Uploaders/Video';
const RENDERERS = {
    [PostDataType.TextPost]: TextContent,
    [PostDataType.ImagePost]: Image,
    [PostDataType.VideoPost]: Video,
    [PostDataType.FilePost]: File,
};
const LIST_RENDERERS = {
    [PostDataType.ImagePost]: ImageContentList,
    [PostDataType.VideoPost]: VideoContentList,
    [PostDataType.FilePost]: FileContentList,
};
const PostEditorContent = (_a) => {
    var { data, dataType, onChangeText, onRemoveChild, placeholder } = _a, props = __rest(_a, ["data", "dataType", "onChangeText", "onRemoveChild", "placeholder"]);
    const isList = Array.isArray(data);
    const Renderer = (isList ? LIST_RENDERERS : RENDERERS)[dataType];
    if (!data || !Renderer)
        return null;
    const dataProps = isList ? { items: data } : data;
    return (React.createElement(Renderer, Object.assign({}, dataProps, { placeholder: placeholder, onChangeText: onChangeText, onRemove: onRemoveChild }, props)));
};
PostEditorContent.propTypes = {
    id: PropTypes.string,
    data: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    dataType: PropTypes.oneOf(Object.values(PostDataType)),
    placeholder: PropTypes.string,
    onChangeText: PropTypes.func,
    onRemoveChild: PropTypes.func,
};
export default PostEditorContent;
//# sourceMappingURL=index.js.map